import { Card } from "@ui/Card";
import { ListTitle } from "@ui/ListTitle";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Modal } from "@ui/molecules/Modal/Modal";
import { VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { createResource, For, Show } from "solid-js";
import { listCategoryGroups } from "@/client";
import { categoryHref } from "../utils/categoryHref";

type Props = {
	open: () => boolean;
	onClose: () => void;
};

export const AllCategories = (props: Props) => {
	const [catalog] = createResource(
		() => props.open(),
		async (isOpen) => {
			if (!isOpen) {
				return null;
			}
			const res = await listCategoryGroups();
			return res.data ?? null;
		},
	);

	const title = () => {
		const total = catalog()?.total;
		return total != null ? `${total} categories ` : "Categories";
	};

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			preTitle="All categories"
			title={title()}
			class="askgvt-all-cats-modal"
		>
			<Show
				when={!catalog.loading}
				fallback={
					<Text size="small" color="fg3">
						Loading categories…
					</Text>
				}
			>
				<For each={catalog()?.groups ?? []}>
					{(group) => (
						<VStack spacing="intermediate" style={{ "margin-bottom": "2rem" }}>
							<ListTitle>{group.group}</ListTitle>
							<div class="askgvt-all-cats">
								<For each={group.items ?? []}>
									{(category) => (
										<Card
											as="a"
											class="askgvt-all-cat"
											href={categoryHref(category.id ?? "")}
										>
											<MaterialSymbol
												symbol={category.icon ?? ""}
												color="fg3"
											/>
											<Text
												as="span"
												size="standard"
												weight="semi-bold"
												color="ink"
												ellipsis
											>
												{category.name}
											</Text>
										</Card>
									)}
								</For>
							</div>
						</VStack>
					)}
				</For>
			</Show>
		</Modal>
	);
};
